module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Moon Cutters")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flush-left-space-after"
  }, [_vm._v("This ebook is copyright material and must not be copied, reproduced, transferred, distributed, leased, licensed or publicly performed or used in any way except as specifically permitted in writing by the publishers, as allowed under the terms and conditions under which it was purchased or as strictly permitted by applicable copyright law. Any unauthorised distribution or use of this text may be a direct infringement of the author’s and publisher’s rights and those responsible may be liable in law accordingly.")]), _vm._v(" "), _c('div', {
    staticClass: "pgbrk"
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First published in Great Britain 2013 by")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("SEVERN HOUSE PUBLISHERS LTD of")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("9-15 High Street, Sutton, Surrey, England, SM1 1DF.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First published in the USA 2014 by")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("SEVERN HOUSE PUBLISHERS of")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("110 East 59"), _c('sup', [_vm._v("th")]), _vm._v(" Street, New York, N.Y. 10022")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("eBook edition first published in 2014 by Severn House Digital an imprint of Severn House Publishers Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("Copyright © 2013 by Janet Woods.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("The right of Janet Woods to be identified as the author of this work has been asserted in accordance with the Copyright, Designs   Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("British Library Cataloguing in Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Woods, Janet, 1939- author.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Moon Cutters.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1. Sisters–Fiction. 2. Orphans–Fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("I. Title")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("823.9’2-dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-13: 978-0-7278-8335-3 (cased)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("ISBN-13: 978-1-78010-478-2 (ePub)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space-after"
  }, [_vm._v("Except where actual historical events and characters are being described for the storyline of this novel, all situations in this publication are fictitious and any resemblance to living persons is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This ebook produced by")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Palimpsest Book Production Limited,")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Falkirk, Stirlingshire, Scotland.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abc3356","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/copyright.vue
// module id = 69
// module chunks = 0